// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"157b5791","220":"f15945d8","422":"685f5ec9","441":"19d44dbd","495":"80bf86c6","690":"990668a3","854":"c5a05b41"}[chunkId] + ".chunk.js";
};